module.exports = __webpack_public_path__ + "img/8.e55c0796.jpeg";